import type { TextFieldSchema } from '@carboncopyco/editor-utils';
import { FieldPanel } from './FieldPanel';
import type { BaseFieldProps } from './types';
import { useDebouncedValue } from './useDebouncedValue';

export type TextFieldProps = BaseFieldProps<TextFieldSchema, string>;

export const TextField = ({
  value,
  field,
  readOnly,
  editableField,
  onChangeField,
  onChangeValue,
  onRemoveField,
}: TextFieldProps) => {
  const [innerValue, setInnerValue] = useDebouncedValue(value, onChangeValue);

  return (
    <FieldPanel
      field={field}
      editable={editableField}
      onChange={onChangeField}
      onRemoveField={onRemoveField}
    >
      <div className="flex items-center justify-between gap-1 rounded-md placeholder-ds-natural-300 leading-ds-300 box-border outline !outline-1 outline-offset-[-1px] tracking-ds-normal font-ds-inter focus:outline-ds-primary-300 focus-within:outline-ds-primary-300 px-3 py-2 text-ds-400 font-ds-normal h-ds-lg-input bg-white text-ds-natural-600 outline-ds-natural-100">
        <input
          className="outline-none border-none p-0 focus:ring-0 flex-1 h-full bg-transparent w-full"
          type="text"
          name={field.jsonPath}
          value={innerValue}
          onChange={(e) => setInnerValue(e.target?.value)}
          style={{
            cursor: 'inherit',
            fontSize: 'inherit',
          }}
          readOnly={readOnly}
        />
      </div>
    </FieldPanel>
  );
};
